import { render, staticRenderFns } from "./Direcionamento.vue?vue&type=template&id=7c9e8904&scoped=true&"
import script from "./Direcionamento.vue?vue&type=script&lang=js&"
export * from "./Direcionamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9e8904",
  null
  
)

export default component.exports